import { container } from '@eureka/services'
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { Nav, GetNavListResponse } from '../../types'

export function getHistoryList(filters: string[]) {
    return container.RnDHttp.get<ICoreDataWrapper<GetNavListResponse>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/air/records`,
        params: {
            filters: filters.join(','),
            page: 1,
            pageSize: 100,
        },
    }).then((res) => {
        return res.data
    })
}

export function removeHistory(data: Nav, filters: string[] = []) {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/air/remove`,
        params: {
            filters: filters.join(','),
        },
        data,
    }).then((res) => {
        return res.status
    })
}

export function removeAllRecords() {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/air/records`,
    }).then((res) => {
        return res.status
    })
}
